import pluralize from 'pluralize';

export function useValidationText(resource) {
  const validationErrs = resource.validate();
  if (validationErrs.length === 0) {
    return { valid: true, validationText: 'All required info entered' };
  }

  const fieldsWithErrors = new Set(validationErrs.map((err) => err.details?.attribute));
  const onlyRequiredFieldErrors = validationErrs.every(err => err.errorCode === 'required-attribute');
  return {
    valid: false,
    validationText: onlyRequiredFieldErrors
      ? `${fieldsWithErrors.size} missing ${pluralize('item', fieldsWithErrors.size)}`
      : `${fieldsWithErrors.size} invalid ${pluralize('item', fieldsWithErrors.size)}`,
  };
}
